export default "__VITE_ASSET__dbb57588__"